import React from 'react';
import { IconProps } from '../types/types';

const ABBV: React.FC<IconProps> = (props) => (
    <svg viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg" role="img" {...props}><path fill="#00003A" d="M0 0h18v18H0z"/><path d="M4 8.511A3.512 3.512 0 017.513 5h2.244c1.758 0 3.245 1.3 3.48 3.041l.13.953L14 13h-.5c-.5 0-.585-.532-.652-.94l-.112-.689A3.513 3.513 0 019.771 13H7.513A3.512 3.512 0 014 9.489V8.51zm8.243-.336a2.509 2.509 0 00-2.486-2.172H7.513a2.509 2.509 0 00-2.51 2.508v.978a2.509 2.509 0 002.51 2.508H9.77c.896 0 1.694-.473 2.139-1.197.358-.584.343-1.307.338-1.992l-.005-.633z" fill="#fff"/></svg>
);

export default ABBV;